import baseService from "./baseService";
import { store } from "../Redux/store";


export const getAllCompensationTypes = async (includeInactive = false) => {
  try {
    const queryParams = includeInactive ? '?includeInactive=true' : '';
    const response = await baseService.get(`/compensation-types${queryParams}`);
    return response?.data;
  } catch (error) {
    return error;
  }
};

export const createCompensationType = async (compensationTypeData) => {
  try {
    const response = await baseService.post('/compensation-types', compensationTypeData);
    return response?.data;
  } catch (error) {
    return error;
  }
};

export const updateCompensationType = async (id, compensationTypeData) => {
  try {
    const response = await baseService.put(`/compensation-types/${id}`, compensationTypeData);
    return response?.data;
  } catch (error) {
    return error;
  }
};

export const toggleCompensationTypeStatus = async (id) => {
  try {
    const response = await baseService.delete(`/compensation-types/${id}/toggle-status`);
    return response?.data;
  } catch (error) {
    return error;
  }
};

export const deleteCompensationType = async (id) => {
  try {
    const response = await baseService.post('/compensation-types/delete', { id });
    return response?.data;
  } catch (error) {
    return error;
  }
};

export default {
  getAllCompensationTypes,
  createCompensationType,
  updateCompensationType,
  toggleCompensationTypeStatus,
  deleteCompensationType
};